"use strict";

// static data (not mutable by the user) printed by the server via template tag
const template = document.querySelector("template");
let staticData;
try {
    staticData = JSON.parse(template.innerHTML);
} catch (e) {
    staticData = {};
}


module.exports = staticData;
